
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSim = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 29,
  viewBox: "0 0 24 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 28.181h-17c-1.379 0-2.5-1.09-2.5-2.432V3.432C1 2.09 2.121 1 3.5 1h13.171a2.52 2.52 0 0 1 1.768.712l3.829 3.724c.472.46.732 1.07.732 1.72v18.593c0 1.341-1.122 2.432-2.5 2.432zM22 7.155c0-.383-.16-.76-.439-1.031L17.732 2.4a1.528 1.528 0 0 0-1.06-.427H3.5c-.827 0-1.5.654-1.5 1.459v22.317c0 .805.673 1.46 1.5 1.46h17c.827 0 1.5-.655 1.5-1.46V7.155zM16.5 25.29h-10c-.827 0-1.5-.654-1.5-1.459v-10.7c0-.804.673-1.459 1.5-1.459h10c.827 0 1.5.655 1.5 1.46v10.7c0 .804-.673 1.458-1.5 1.458zm.5-12.158a.495.495 0 0 0-.5-.487H15v3.405c0 .268-.224.486-.5.486s-.5-.218-.5-.486v-3.405h-2v3.405a.494.494 0 0 1-.5.486.493.493 0 0 1-.5-.486v-3.405H9v3.405a.494.494 0 0 1-.5.486.493.493 0 0 1-.5-.486v-3.405H6.5c-.276 0-.5.219-.5.487v10.7c0 .268.224.486.5.486H8v-3.405c0-.268.223-.486.5-.486.276 0 .5.218.5.486v3.405h2v-3.405c0-.268.223-.486.5-.486.276 0 .5.218.5.486v3.405h2v-3.405c0-.268.224-.486.5-.486s.5.218.5.486v3.405h1.5c.275 0 .5-.218.5-.487v-10.7z",
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)",
  fill: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"29\" viewBox=\"0 0 24 29\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\">\r\n            <path d=\"M19.5 27.181h-17c-1.379 0-2.5-1.09-2.5-2.432V2.432C0 1.09 1.121 0 2.5 0h13.171c.668 0 1.296.253 1.768.712l3.829 3.724c.472.46.732 1.07.732 1.72v18.593c0 1.341-1.122 2.432-2.5 2.432zM21 6.155c0-.383-.16-.76-.439-1.031L16.732 1.4c-.279-.272-.665-.427-1.06-.427H2.5c-.827 0-1.5.654-1.5 1.459v22.317c0 .805.673 1.46 1.5 1.46h17c.827 0 1.5-.655 1.5-1.46V6.155zM15.5 24.29h-10c-.827 0-1.5-.654-1.5-1.459v-10.7c0-.804.673-1.459 1.5-1.459h10c.827 0 1.5.655 1.5 1.46v10.7c0 .804-.673 1.458-1.5 1.458zm.5-12.158c0-.268-.225-.487-.5-.487H14v3.405c0 .268-.224.486-.5.486s-.5-.218-.5-.486v-3.405h-2v3.405c0 .268-.224.486-.5.486-.277 0-.5-.218-.5-.486v-3.405H8v3.405c0 .268-.224.486-.5.486-.277 0-.5-.218-.5-.486v-3.405H5.5c-.276 0-.5.219-.5.487v10.7c0 .268.224.486.5.486H7v-3.405c0-.268.223-.486.5-.486.276 0 .5.218.5.486v3.405h2v-3.405c0-.268.223-.486.5-.486.276 0 .5.218.5.486v3.405h2v-3.405c0-.268.224-.486.5-.486s.5.218.5.486v3.405h1.5c.275 0 .5-.218.5-.487v-10.7z\" transform=\"translate(1 1)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-sim.519e4c238223465a7f2cba9cebf07989.svg"),
        {
          React: SvgIconsSim,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      